import React from 'react';
import { Route } from 'react-router';

import { LoadableSuggestionConfirmation } from './helpers/loadables';

// Route configuration
// Read more https://github.com/ReactTraining/react-router/tree/v3.2.1/docs
export default (
  <>
    <Route
      path="/suggest-confirm/:eventId"
      whiteBackground
      component={LoadableSuggestionConfirmation}
    />
  </>
);
